<script setup lang="ts">

</script>

<template>
  <div class="relative z-0">
    <TStage />
  </div>
</template>
